import { render, staticRenderFns } from "./summarize.vue?vue&type=template&id=1254ee8c&"
import script from "./summarize.vue?vue&type=script&lang=js&"
export * from "./summarize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports